// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b8a10f92","455":"e62c1a16","977":"8ca5001b"}[chunkId] + ".chunk.js";
};